import { render, staticRenderFns } from "./index.vue?vue&type=template&id=21ee335c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ee335c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/NewRabbit/newRabbitAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21ee335c')) {
      api.createRecord('21ee335c', component.options)
    } else {
      api.reload('21ee335c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=21ee335c&scoped=true&", function () {
      api.rerender('21ee335c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/reports/hongbaoStatic/index.vue"
export default component.exports